import { render } from "./balanceBusiness.vue?vue&type=template&id=0f2e5e83&scoped=true"
import script from "./balanceBusiness.vue?vue&type=script&lang=js"
export * from "./balanceBusiness.vue?vue&type=script&lang=js"

import "./balanceBusiness.vue?vue&type=style&index=0&id=0f2e5e83&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2e5e83"]])

export default __exports__